if (!customElements.get('pdp-offers')) {
  customElements.define(
    'pdp-offers',
    class PdpOffers extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.pdp-offers__track');
        this.dots = Array.from(this.querySelectorAll('.pdp-offers__dot'));
        if (!this.track || !this.dots.length) return;

        this.onScroll = () => this.syncDots();
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.goTo(index));
        });
        this.syncDots();
      }

      cardStride() {
        const card = this.track.querySelector('.pdp-offers__card');
        if (!card) return this.track.clientWidth;
        const styles = window.getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 12;
        return card.getBoundingClientRect().width + gap;
      }

      syncDots() {
        const stride = this.cardStride();
        if (!stride) return;
        const index = Math.round(this.track.scrollLeft / stride);
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }

      goTo(index) {
        this.track.scrollTo({ left: index * this.cardStride(), behavior: 'smooth' });
      }
    }
  );
}

// if (!customElements.get('pdp-delivery')) {
//   customElements.define(
//     'pdp-delivery',
//     class PdpDelivery extends HTMLElement {
//       connectedCallback() {
//         this.form = this.querySelector('form');
//         this.input = this.querySelector('.pdp-delivery__input');
//         this.result = this.querySelector('.pdp-delivery__result');
//         if (!this.form || !this.input) return;

//         this.form.addEventListener('submit', (event) => {
//           event.preventDefault();
//           const pin = this.input.value.trim();
//           if (!/^\d{6}$/.test(pin)) {
//             this.setResult(this.dataset.errorMessage || 'Enter a valid 6-digit PIN', true);
//             return;
//           }
//           this.setResult(this.dataset.successMessage || 'Delivery is available to this PIN.', false);
//         });
//       }

//       setResult(message, isError) {
//         if (!this.result) return;
//         this.result.textContent = message;
//         this.result.classList.toggle('is-error', Boolean(isError));
//         this.result.hidden = !message;
//       }
//     }
//   );
// }

(() => {
  const syncHeaderHeight = () => {
    const header =
      document.querySelector('.section-header') ||
      document.querySelector('sticky-header') ||
      document.querySelector('.header-custom');
    if (!header) return;
    document.documentElement.style.setProperty(
      '--header-height',
      `${Math.round(header.getBoundingClientRect().height)}px`
    );
  };

  syncHeaderHeight();
  window.addEventListener('resize', syncHeaderHeight);
  window.addEventListener('load', syncHeaderHeight);
})();

(() => {
  const bindSliderLoader = (frame) => {
    const slider = frame.querySelector('.pdp-media-slider');
    const bar = frame.querySelector('.pdp-slider-loader__bar');
    if (!slider || !bar) return;

    const update = () => {
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      const ratio = slider.scrollWidth > 0 ? slider.clientWidth / slider.scrollWidth : 1;
      const thumb = Math.min(Math.max(ratio, 0.18), 1);
      const progress = maxScroll > 0 ? slider.scrollLeft / maxScroll : 0;
      bar.style.width = `${thumb * 100}%`;
      bar.style.left = `${progress * (1 - thumb) * 100}%`;
    };

    slider.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  document.querySelectorAll('.pdp-ack .pdp-media-frame').forEach(bindSliderLoader);
})();

(() => {
  const nativeSmooth =
    typeof CSS !== 'undefined' &&
    CSS.supports('selector(::details-content)') &&
    CSS.supports('interpolate-size', 'allow-keywords');
  if (nativeSmooth) return;

  const animate = (details, open) => {
    const content = details.querySelector('.accordion__content');
    if (!content) {
      details.open = open;
      return;
    }

    content.style.overflow = 'hidden';
    content.style.transition = 'none';

    if (open) {
      details.open = true;
      content.style.height = '0px';
      content.style.opacity = '0';
      const end = content.scrollHeight;
      content.getBoundingClientRect();
      content.style.transition = 'height 0.4s ease, opacity 0.3s ease';
      content.style.height = `${end}px`;
      content.style.opacity = '1';
    } else {
      content.style.height = `${content.scrollHeight}px`;
      content.style.opacity = '1';
      content.getBoundingClientRect();
      content.style.transition = 'height 0.4s ease, opacity 0.3s ease';
      content.style.height = '0px';
      content.style.opacity = '0';
    }

    const done = (event) => {
      if (event.propertyName !== 'height') return;
      content.removeEventListener('transitionend', done);
      content.style.height = '';
      content.style.opacity = '';
      content.style.overflow = '';
      content.style.transition = '';
      if (!open) details.open = false;
    };
    content.addEventListener('transitionend', done);
  };

  document.querySelectorAll('.pdp-ack .product__accordion details').forEach((details) => {
    const summary = details.querySelector('summary');
    if (!summary) return;
    summary.addEventListener('click', (event) => {
      event.preventDefault();
      animate(details, !details.open);
    });
  });
})();

if (!customElements.get('pdp-sticky-bar')) {
  customElements.define(
    'pdp-sticky-bar',
    class PdpStickyBar extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.sectionId = this.dataset.sectionId;

        this.productInfo =
          document.querySelector(`#MainProduct-${this.sectionId}`) || document.querySelector('product-info');
        this.addToCartBtn = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.mainBuyNow = this.productInfo?.querySelector('.pdp-buy-now');

        this.qtyWrap = this.querySelector('[data-sticky-qty]');
        this.qtyValue = this.querySelector('[data-sticky-qty-value]');
        this.addBtn = this.querySelector('[data-sticky-add]');
        this.buyBtn = this.querySelector('[data-sticky-buy]');
        this.priceEl = this.querySelector(`#pdp-sticky-price-${this.sectionId}`);

        this.cartLine = null;
        this.cartQuantity = parseInt(this.qtyValue?.textContent, 10) || 0;
        this.isUpdating = false;
        this.syncTimer = null;
        this.updateGuardTimer = null;

        this.setupVisibility();
        this.setupActions();
        this.setupCartDrawerObserver();
        this.syncPriceFromDom();
        this.syncFromCart();

        this.cartUnsub = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          this.onCartChange(event);
        });

        this.cartErrorUnsub = subscribe(PUB_SUB_EVENTS.cartError, () => {
          this.setLoading(this.addBtn, false);
          this.setLoading(this.buyBtn, false);
          this.isUpdating = false;
          this.syncButtonState();
        });
        this.variantUnsub = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data?.sectionId !== this.sectionId) return;
          this.refreshPurchaseRefs();
          this.setupVisibility();
          this.syncPriceFromDom();
          this.syncFromCart();
          this.syncButtonState();
        });

        // Extra reliability: cart drawer quantity changes can happen with timing quirks.
        // Use click delegation so we always resync immediately after the user action.
        this.cartClickHandler = (e) => {
          const target = e.target;
          if (!target) return;
          const actionEl = target.closest(
            '.cart-drawer, cart-drawer, cart-drawer-items, cart-items, .cart-item, .cart-drawer__inner'
          );
          // Only trigger for relevant interactions
          const isQuantityButton = Boolean(target.closest('.quantity__button[name="minus"], .quantity__button[name="plus"]'));
          const isRemove = Boolean(
            target.closest(
              'cart-remove-button, .cart-remove-button, [name="remove"], [data-cart-remove], a[href*="/cart/change"]'
            )
          );
          if (!actionEl && !isQuantityButton && !isRemove) return;
          if (!isQuantityButton && !isRemove) return;
          // For direct user clicks, wait a bit longer than pubsub events.
          // The server cart mutation might still be in flight when the click happens.
          this.setLoading(this.addBtn, false);
          this.setLoading(this.buyBtn, false);
          this.isUpdating = false;
          this.scheduleSync(650);
        };
        document.addEventListener('click', this.cartClickHandler, { passive: true });

        // Some themes update cart through change/submit handlers instead of click-only controls.
        this.cartInputHandler = (e) => {
          const target = e.target;
          if (!target) return;
          const qtyInput = target.closest?.(
            '.cart-drawer input[name="updates[]"], cart-drawer-items input[name="updates[]"], cart-items input[name="updates[]"]'
          );
          if (!qtyInput) return;
          this.scheduleSync(450);
        };
        this.cartSubmitHandler = (e) => {
          const form = e.target;
          if (!(form instanceof HTMLFormElement)) return;
          const hasCartControl = form.querySelector(
            'cart-remove-button, .cart-remove-button, [name="remove"], input[name="updates[]"]'
          );
          if (!hasCartControl) return;
          this.scheduleSync(500);
        };
        document.addEventListener('change', this.cartInputHandler, { passive: true });
        document.addEventListener('submit', this.cartSubmitHandler, { passive: true });

        // Drawer open/close can race with cart section re-renders.
        // Resync after close interactions so sticky state stays actionable.
        this.cartDrawerCloseHandler = (e) => {
          const target = e.target;
          if (!target) return;
          const isCloseAction = Boolean(
            target.closest(
              'cart-drawer .drawer__close, cart-drawer .drawer__overlay, cart-drawer [aria-label*="Close"], cart-drawer [data-close]'
            )
          );
          if (!isCloseAction) return;
          this.scheduleSync(450);
        };
        document.addEventListener('click', this.cartDrawerCloseHandler, { passive: true });

        this.sectionUnloadHandler = (event) => {
          if (event.detail?.sectionId === this.sectionId) this.remove();
        };
        document.addEventListener('shopify:section:unload', this.sectionUnloadHandler);

        this.relocateToBody();
      }

      relocateToBody() {
        document.querySelectorAll(`body > pdp-sticky-bar[data-section-id="${this.sectionId}"]`).forEach((el) => {
          if (el !== this) el.remove();
        });
        if (this.parentElement === document.body) return;
        this.isRelocating = true;
        document.body.appendChild(this);
        this.isRelocating = false;
      }

      disconnectedCallback() {
        if (this.isRelocating || !this.initialized) return;

        this.initialized = false;
        this.cartUnsub?.();
        this.cartErrorUnsub?.();
        this.variantUnsub?.();
        this.observer?.disconnect();
        this.removeVisibilityListeners();
        this.cartDrawerObserver?.disconnect();
        if (this.sectionUnloadHandler) {
          document.removeEventListener('shopify:section:unload', this.sectionUnloadHandler);
        }
        clearTimeout(this.syncTimer);
        clearTimeout(this.updateGuardTimer);
        if (this.cartClickHandler) document.removeEventListener('click', this.cartClickHandler);
        if (this.cartInputHandler) document.removeEventListener('change', this.cartInputHandler);
        if (this.cartSubmitHandler) document.removeEventListener('submit', this.cartSubmitHandler);
        if (this.cartDrawerCloseHandler) document.removeEventListener('click', this.cartDrawerCloseHandler);
      }

      getVariantId() {
        this.productInfo =
          document.querySelector(`#MainProduct-${this.sectionId}`) || document.querySelector('product-info');

        const productForm =
          this.productInfo?.querySelector(`product-form[data-section-id="${this.sectionId}"]`) ||
          this.productInfo?.querySelector('product-form');
        const fromProductForm = productForm?.querySelector('input[name="id"]')?.value;
        if (fromProductForm) return fromProductForm;

        const formByIdInput = document.querySelector(`#product-form-${this.sectionId} input[name="id"]`)?.value;
        if (formByIdInput) return formByIdInput;

        const hiddenVariantInput = this.productInfo?.querySelector('.product-variant-id')?.value;
        if (hiddenVariantInput) return hiddenVariantInput;

        const variantFromUrl = new URLSearchParams(window.location.search).get('variant');
        if (variantFromUrl) return variantFromUrl;

        return null;
      }

      getItemVariantId(item) {
        return item?.variant_id ?? item?.variantId ?? item?.id;
      }

      getMainQuantityInput() {
        return document.getElementById(`Quantity-${this.sectionId}`);
      }

      getProductForm() {
        return this.productInfo?.querySelector('product-form');
      }

      refreshPurchaseRefs() {
        this.addToCartBtn = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.mainBuyNow = this.productInfo?.querySelector('.pdp-buy-now');
      }

      onCartChange(event) {
        clearTimeout(this.updateGuardTimer);
        this.setLoading(this.addBtn, false);
        this.setLoading(this.buyBtn, false);
        this.isUpdating = false;

        // If payload has full cart items, update immediately.
        if (Array.isArray(event?.cartData?.items)) {
          this.applyCartData(event.cartData);
        }

        // Always do a follow-up refetch: some cart updates can have timing quirks
        // where /cart.js hasn't settled yet when the event fires.
        this.scheduleSync(300);
      }

      setupCartDrawerObserver() {
        this.cartDrawerObserver?.disconnect();

        const cartRoot =
          document.querySelector('cart-drawer') ||
          document.querySelector('.rebuy-cart') ||
          document.querySelector('#CartDrawer');
        if (!cartRoot) return;

        this.cartDrawerObserver = new MutationObserver(() => {
          this.scheduleSync();
        });
        this.cartDrawerObserver.observe(cartRoot, {
          childList: true,
          subtree: true,
        });
      }

      scheduleSync(delayMs = 300) {
        clearTimeout(this.syncTimer);
        this.syncTimer = window.setTimeout(() => {
          this.syncFromCart();
        }, delayMs);
      }

      setupMainQuantityObserver() {
        const input = this.getMainQuantityInput();
        if (!input) return;

        this.qtyObserver = new MutationObserver(() => {
          this.syncFromMainQuantityInput();
        });
        this.qtyObserver.observe(input, {
          attributes: true,
          attributeFilter: ['data-cart-quantity', 'value'],
        });
      }

      applyCartData(cartData) {
        const variantId = this.getVariantId();
        if (!Array.isArray(cartData?.items)) return;
        if (!variantId) {
          // Prevent stale quantity state from blocking "Add" when variant lookup
          // momentarily fails during dynamic DOM updates.
          this.cartLine = null;
          this.cartQuantity = 0;
          this.updateUI();
          return;
        }

        const index = cartData.items.findIndex(
          (item) => String(this.getItemVariantId(item)) === String(variantId)
        );

        if (index >= 0) {
          this.cartLine = index + 1;
          this.cartQuantity = cartData.items[index].quantity;
        } else {
          this.cartLine = null;
          this.cartQuantity = 0;
        }

        this.updateUI();
      }

      syncFromMainQuantityInput() {
        const input = this.getMainQuantityInput();
        if (!input) return;

        const rawQty = input.dataset.cartQuantity;
        if (typeof rawQty === 'undefined' || rawQty === null || rawQty === '') return;
        const nextQty = parseInt(rawQty, 10);
        if (Number.isNaN(nextQty)) return;
        if (nextQty === this.cartQuantity) return;

        this.cartQuantity = nextQty;

        if (nextQty === 0) {
          this.cartLine = null;
          this.updateUI();
          this.scheduleSync();
          return;
        }

        this.updateUI();
        this.scheduleSync();
      }

      async syncCartLine() {
        try {
          const cart = await fetch(`${routes.cart_url}.js`, { cache: 'no-store' }).then((response) => response.json());
          const variantId = this.getVariantId();
          if (!variantId) return;

          const index = cart.items.findIndex(
            (item) => String(this.getItemVariantId(item)) === String(variantId)
          );
          this.cartLine = index >= 0 ? index + 1 : null;
        } catch (error) {
          console.error(error);
        }
      }

      removeVisibilityListeners() {
        if (!this.onVisibilityChange) return;
        window.removeEventListener('scroll', this.onVisibilityChange);
        window.removeEventListener('resize', this.onVisibilityChange);
        window.removeEventListener('orientationchange', this.onVisibilityChange);
      }

      getVisibilityTarget() {
        const productInfo =
          document.querySelector(`#MainProduct-${this.sectionId}`) || document.querySelector('product-info');
        return (
          productInfo?.querySelector('.pdp-purchase') ||
          productInfo?.querySelector('.product-form__quantity') ||
          document.getElementById(`ProductSubmitButton-${this.sectionId}`)
        );
      }

      hasScrolledPast(el) {
        if (!el) return false;
        const rect = el.getBoundingClientRect();
        // Zero box means the node isn't laid out yet (or display:contents collapsed).
        // That is NOT "scrolled past" — otherwise the bar shows on first paint.
        if (rect.width <= 0 && rect.height <= 0) return false;
        return rect.bottom <= 0;
      }

      setupVisibility() {
        this.footerEl = document.querySelector('footer.footer_sec') || document.querySelector('.footer_sec');
        this.refreshPurchaseRefs();

        this.observer?.disconnect();
        this.removeVisibilityListeners();

        this.onVisibilityChange = () => {
          const target = this.getVisibilityTarget();
          this.atcScrolledPast = this.hasScrolledPast(target);

          const viewportHeight = window.visualViewport?.height || window.innerHeight;
          if (this.footerEl) {
            this.footerInView = this.footerEl.getBoundingClientRect().top < viewportHeight;
          } else {
            this.footerInView = false;
          }

          this.updateStickyVisibility();
        };

        this.observer = new IntersectionObserver(() => this.onVisibilityChange(), {
          threshold: [0, 1],
        });

        const target = this.getVisibilityTarget();
        if (target) this.observer.observe(target);
        if (this.footerEl) this.observer.observe(this.footerEl);

        window.addEventListener('scroll', this.onVisibilityChange, { passive: true });
        window.addEventListener('resize', this.onVisibilityChange);
        window.addEventListener('orientationchange', this.onVisibilityChange);
        this.onVisibilityChange();
        requestAnimationFrame(() => this.onVisibilityChange());
      }

      updateStickyVisibility() {
        const show = Boolean(this.atcScrolledPast) && !this.footerInView;
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
      }

      setupActions() {
        this.addBtn?.addEventListener('click', () => this.handleAddToCart());
        this.buyBtn?.addEventListener('click', () => this.handleBuyNow());

        this.qtyWrap?.querySelector('[name="minus"]')?.addEventListener('click', () => this.changeCartQty(-1));
        this.qtyWrap?.querySelector('[name="plus"]')?.addEventListener('click', () => this.changeCartQty(1));
      }

      handleAddToCart() {
        this.refreshPurchaseRefs();
        const productForm = this.getProductForm();
        const form = productForm?.querySelector('form');
        const submitButton = this.addToCartBtn;
        const variantId = this.getVariantId();

        if (!submitButton) return;

        // Fallback: the main submit button can occasionally remain disabled/"unavailable"
        // after cart mutations. If we still have a selected variant, attempt direct add.
        if ((submitButton.disabled || this.addBtn?.disabled) && variantId) {
          this.addVariantDirectly(variantId);
          return;
        }

        if (submitButton.disabled || this.addBtn?.disabled) return;

        this.setLoading(this.addBtn, true);
        submitButton.removeAttribute('aria-disabled');
        submitButton.classList.remove('loading');

        if (form?.requestSubmit) {
          form.requestSubmit(submitButton);
        } else {
          submitButton.click();
        }
      }

      async addVariantDirectly(variantId) {
        this.setLoading(this.addBtn, true);
        try {
          const response = await fetch(`${routes.cart_add_url}`, {
            ...fetchConfig('javascript'),
            headers: {
              ...fetchConfig('javascript').headers,
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              items: [{ id: Number(variantId), quantity: 1 }],
            }),
          });
          const data = await response.json();
          if (data?.status || data?.errors) {
            throw new Error(data.errors || data.description || data.message || 'Failed to add item to cart');
          }
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'pdp-sticky-bar',
            productVariantId: variantId,
            cartData: data,
          });
        } catch (error) {
          console.error(error);
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'pdp-sticky-bar',
            productVariantId: variantId,
            errors: error?.message || 'Unable to add item to cart',
          });
        } finally {
          this.setLoading(this.addBtn, false);
          this.scheduleSync(200);
          this.scheduleSync(800);
        }
      }

      handleBuyNow() {
        this.refreshPurchaseRefs();
        const productForm = this.getProductForm();
        const form = productForm?.querySelector('form');
        const buyButton = this.mainBuyNow;

        if (!buyButton || buyButton.disabled || this.buyBtn?.disabled) return;

        this.setLoading(this.buyBtn, true);
        buyButton.removeAttribute('aria-disabled');
        buyButton.classList.remove('loading');

        if (form?.requestSubmit) {
          form.requestSubmit(buyButton);
        } else {
          buyButton.click();
        }
      }

      setLoading(button, loading) {
        if (!button) return;
        button.classList.toggle('loading', loading);
        button.toggleAttribute('aria-disabled', loading);
      }

      async syncFromCart() {
        const variantId = this.getVariantId();
        if (!variantId) return;

        try {
          const cart = await fetch(`${routes.cart_url}.js`, { cache: 'no-store' }).then((response) => response.json());
          // /cart.js returns the full cart shape (items, item_count, etc.)
          // Ensure we read quantity for the currently selected variant.
          this.applyCartData(cart);
        } catch (error) {
          console.error(error);
        }
      }

      updateUI() {
        const inCart = this.cartQuantity > 0;

        this.qtyWrap?.classList.toggle('hidden', !inCart);
        this.addBtn?.classList.toggle('hidden', inCart);

        if (this.qtyValue) {
          this.qtyValue.textContent = String(this.cartQuantity);
        }

        if (!inCart) {
          this.setLoading(this.addBtn, false);
          this.isUpdating = false;
        }

        this.syncButtonState();
      }

      syncButtonState() {
        this.refreshPurchaseRefs();

        const disabled = Boolean(this.addToCartBtn?.disabled);
        const label = this.addToCartBtn?.querySelector('span')?.textContent?.trim();
        const normalizedLabel = (label || '').toLowerCase();
        const isActuallyUnavailable =
          disabled &&
          (normalizedLabel.includes('sold out') ||
            normalizedLabel.includes('unavailable') ||
            normalizedLabel.includes('out of stock'));

        if (this.addBtn) {
          // Keep sticky add clickable unless variant is truly unavailable.
          // The main PDP button can be transiently disabled during cart/drawer updates.
          this.addBtn.disabled = isActuallyUnavailable;
          this.addBtn.removeAttribute('aria-disabled');
          const labelEl = this.addBtn.querySelector('span');
          if (labelEl) {
            if (isActuallyUnavailable && label) {
              labelEl.textContent = label;
            } else {
              labelEl.textContent = window.variantStrings?.addToCart || 'Add to cart';
            }
          }
        }

        if (this.buyBtn) {
          this.buyBtn.disabled = isActuallyUnavailable;
          this.buyBtn.classList.toggle('hidden', !this.mainBuyNow || this.mainBuyNow.disabled);
        }

        const minusBtn = this.qtyWrap?.querySelector('[name="minus"]');
        const plusBtn = this.qtyWrap?.querySelector('[name="plus"]');
        if (minusBtn) minusBtn.disabled = this.isUpdating;
        if (plusBtn) plusBtn.disabled = this.isUpdating;
      }

      syncPriceFromDom() {
        const source = document.getElementById(`price-${this.sectionId}`);
        if (source && this.priceEl) {
          this.priceEl.innerHTML = source.innerHTML;
        }

        const title = this.productInfo?.querySelector('.pdp-head__title');
        const titleEl = this.querySelector('.pdp-sticky-bar__title');
        if (title && titleEl) {
          titleEl.textContent = title.textContent.trim();
        }
      }

      changeCartQty(delta) {
        if (this.isUpdating) return;

        if (!this.cartLine) {
          // If line mapping is temporarily unavailable (common around drawer
          // re-renders), still allow increment via direct add.
          if (delta > 0) {
            const variantId = this.getVariantId();
            if (variantId) {
              this.addVariantDirectly(variantId);
              return;
            }
          }
          this.scheduleSync(150);
          return;
        }

        const newQty = this.cartQuantity + delta;
        if (newQty < 0) return;

        const cartItems = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
        if (!cartItems?.updateQuantity) {
          this.updateCartQuantityFallback(newQty);
          return;
        }

        this.isUpdating = true;
        this.syncButtonState();
        clearTimeout(this.updateGuardTimer);
        this.updateGuardTimer = window.setTimeout(() => {
          if (!this.isUpdating) return;
          this.isUpdating = false;
          this.syncButtonState();
          this.scheduleSync(150);
        }, 2500);

        cartItems.updateQuantity(this.cartLine, newQty, { currentTarget: this.qtyWrap });
      }

      async updateCartQuantityFallback(newQty) {
        this.isUpdating = true;
        this.syncButtonState();

        try {
          const response = await fetch(`${routes.cart_change_url}`, {
            ...fetchConfig(),
            body: JSON.stringify({
              line: this.cartLine,
              quantity: newQty,
            }),
          });
          const data = await response.json();

          if (data.errors || data.status) {
            throw new Error(data.errors || data.description);
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'pdp-sticky-bar',
            cartData: data,
            variantId: this.getVariantId(),
          });
        } catch (error) {
          console.error(error);
        } finally {
          clearTimeout(this.updateGuardTimer);
          this.isUpdating = false;
          this.syncFromCart();
        }
      }
    }
  );
}

(function () {
  const scrollToReviews = (event) => {
    const link = event.target.closest('[data-pdp-reviews-link]');
    if (!link) return;
    const target = document.getElementById('judgeme_product_reviews');
    if (!target) return;

    event.preventDefault();
    if (window.lenis) {
      window.lenis.scrollTo(target, { offset: -24 });
      return;
    }
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  document.addEventListener('click', scrollToReviews);
})();

if (!customElements.get('pdp-size-guide')) {
  customElements.define(
    'pdp-size-guide',
    class PdpSizeGuide extends HTMLElement {
      connectedCallback() {
        this.popup = this.querySelector('.pdp-size-guide__popup');
        if (!this.popup) return;

        this.onEnter = () => this.open();
        this.onLeave = () => this.close();
        this.onFocusIn = () => this.open();
        this.onFocusOut = (event) => {
          if (!this.contains(event.relatedTarget)) this.close();
        };
        this.onKeydown = (event) => {
          if (event.key === 'Escape') this.close();
        };

        this.addEventListener('mouseenter', this.onEnter);
        this.addEventListener('mouseleave', this.onLeave);
        this.addEventListener('focusin', this.onFocusIn);
        this.addEventListener('focusout', this.onFocusOut);
        this.addEventListener('keydown', this.onKeydown);
      }

      disconnectedCallback() {
        this.removeEventListener('mouseenter', this.onEnter);
        this.removeEventListener('mouseleave', this.onLeave);
        this.removeEventListener('focusin', this.onFocusIn);
        this.removeEventListener('focusout', this.onFocusOut);
        this.removeEventListener('keydown', this.onKeydown);
      }

      open() {
        this.classList.add('is-open');
        this.popup.setAttribute('aria-hidden', 'false');
        this.positionPopup();
      }

      close() {
        this.classList.remove('is-open');
        this.popup.setAttribute('aria-hidden', 'true');
      }

      positionPopup() {
        this.popup.style.left = '0';
        this.popup.style.right = 'auto';
        const rect = this.popup.getBoundingClientRect();
        const pad = 16;
        if (rect.right > window.innerWidth - pad) {
          this.popup.style.left = 'auto';
          this.popup.style.right = '0';
        }
        if (this.popup.getBoundingClientRect().left < pad) {
          this.popup.style.left = '0';
          this.popup.style.right = 'auto';
        }
      }
    }
  );
}

